"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveStudySubjectRandomizationNoResponse = exports.CreateStudySubjectsDownloadUrlResponse = exports.GetStudySubjectDownloadUrlResponse = exports.GetStudySubjectDownloadableDataset = exports.SendEcoaCodeResponse = exports.InvokeStudySubjectAllTriggersResponse = exports.RemoveStudySubjectContactResponse = exports.UpdateStudySubjectContactResponse = exports.RemoveVisitsLikeCycleResponse = exports.AddVisitsLikeCycleResponse = exports.RemoveVisitResponse = exports.AddVisitResponse = exports.InitializeStudySubjectCrfResponse = exports.InitializeStudySubjectVisitResponse = exports.InitializeStudySubjectResponse = exports.GetStudySubjectsSummary = exports.PaginatableStudySubject = exports.GetStudySubjectContactResponse = exports.StudySubjectExportFormat = exports.GetStudySubjectResponse = exports.CreateStudySubjectContactResponse = exports.CreateStudySubjectsResponse = exports.CreateStudySubjectResponse = exports.GetStudySubjectDataResponse = void 0;
const studySubject_1 = require("./entity/studySubject");
class GetStudySubjectDataResponse {
}
exports.GetStudySubjectDataResponse = GetStudySubjectDataResponse;
class CreateStudySubjectResponse {
}
exports.CreateStudySubjectResponse = CreateStudySubjectResponse;
class CreateStudySubjectsResponse {
}
exports.CreateStudySubjectsResponse = CreateStudySubjectsResponse;
class CreateStudySubjectContactResponse {
}
exports.CreateStudySubjectContactResponse = CreateStudySubjectContactResponse;
class GetStudySubjectResponse {
}
exports.GetStudySubjectResponse = GetStudySubjectResponse;
var StudySubjectExportFormat;
(function (StudySubjectExportFormat) {
    StudySubjectExportFormat["Excel"] = "XLS";
    StudySubjectExportFormat["CSV"] = "CSV";
})(StudySubjectExportFormat = exports.StudySubjectExportFormat || (exports.StudySubjectExportFormat = {}));
class GetStudySubjectContactResponse {
}
exports.GetStudySubjectContactResponse = GetStudySubjectContactResponse;
class PaginatableStudySubject extends studySubject_1.StudySubject {
}
exports.PaginatableStudySubject = PaginatableStudySubject;
class GetStudySubjectsSummary {
}
exports.GetStudySubjectsSummary = GetStudySubjectsSummary;
class InitializeStudySubjectResponse {
}
exports.InitializeStudySubjectResponse = InitializeStudySubjectResponse;
class InitializeStudySubjectVisitResponse {
}
exports.InitializeStudySubjectVisitResponse = InitializeStudySubjectVisitResponse;
class InitializeStudySubjectCrfResponse {
}
exports.InitializeStudySubjectCrfResponse = InitializeStudySubjectCrfResponse;
class AddVisitResponse {
}
exports.AddVisitResponse = AddVisitResponse;
class RemoveVisitResponse {
}
exports.RemoveVisitResponse = RemoveVisitResponse;
class AddVisitsLikeCycleResponse {
}
exports.AddVisitsLikeCycleResponse = AddVisitsLikeCycleResponse;
class RemoveVisitsLikeCycleResponse {
}
exports.RemoveVisitsLikeCycleResponse = RemoveVisitsLikeCycleResponse;
class UpdateStudySubjectContactResponse {
}
exports.UpdateStudySubjectContactResponse = UpdateStudySubjectContactResponse;
class RemoveStudySubjectContactResponse {
}
exports.RemoveStudySubjectContactResponse = RemoveStudySubjectContactResponse;
class InvokeStudySubjectAllTriggersResponse {
}
exports.InvokeStudySubjectAllTriggersResponse = InvokeStudySubjectAllTriggersResponse;
class SendEcoaCodeResponse {
}
exports.SendEcoaCodeResponse = SendEcoaCodeResponse;
class GetStudySubjectDownloadableDataset {
}
exports.GetStudySubjectDownloadableDataset = GetStudySubjectDownloadableDataset;
// NOTE: Deprecated, 배포 이후 삭제
class GetStudySubjectDownloadUrlResponse {
}
exports.GetStudySubjectDownloadUrlResponse = GetStudySubjectDownloadUrlResponse;
class CreateStudySubjectsDownloadUrlResponse {
}
exports.CreateStudySubjectsDownloadUrlResponse = CreateStudySubjectsDownloadUrlResponse;
class RetrieveStudySubjectRandomizationNoResponse {
}
exports.RetrieveStudySubjectRandomizationNoResponse = RetrieveStudySubjectRandomizationNoResponse;
//# sourceMappingURL=studySubject.js.map